import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { isLocal } from "@faire/web--source/common/user-agent/isLocal";
import { Button } from "@faire/web--source/slate/Button";
import { Modal } from "@faire/web--source/slate/deprecated/Modal";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import * as React from "react";
import styled from "styled-components";
export var LoggedInAdminWarningModal = function(param) {
    var onClose = param.onClose, signup = param.signup;
    var _useUserStore = useUserStore([
        "emailAddress",
        "logOut"
    ]), emailAddress = _useUserStore.emailAddress, logOut = _useUserStore.logOut;
    var adminLink = isLocal() ? "http://localhost:3003/admin2" : "https://www.faire-stage.com/admin2";
    return /*#__PURE__*/ _jsx(Modal, {
        justify: "center",
        onClose: onClose,
        children: /*#__PURE__*/ _jsxs(Column, {
            align: "center",
            children: [
                signup ? /*#__PURE__*/ _jsx(Typography, {
                    variant: "displaySSansRegular",
                    align: "center",
                    children: "Warning: sign up process will fail"
                }) : null,
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "2x"
                }),
                /*#__PURE__*/ _jsxs(Typography, {
                    variant: "paragraphSansRegular",
                    align: "center",
                    children: [
                        "You are currently logged in as ",
                        emailAddress,
                        " on faire-stage.com."
                    ]
                }),
                signup ? /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraphSansRegular",
                    align: "center",
                    children: "To successfully go through the sign up flow, you must log out."
                }) : null,
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "3x"
                }),
                /*#__PURE__*/ _jsx(StyledButton, {
                    variant: "primary",
                    onClick: function() {
                        return logOut();
                    },
                    children: "Log me out"
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "2x"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "tertiary",
                    linkTo: adminLink,
                    children: "Take me to Admin Portal"
                })
            ]
        })
    });
};
var StyledButton = styled(Button).withConfig({
    componentId: "sc-149149e5-0"
})([
    "width:100%;"
]);
